// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3PLzw","header":"ClearentDisclaimer_header__1syeh","inner":"ClearentDisclaimer_inner__2uoxr"};